import {schema} from 'normalizr'

export const photoSchema = new schema.Entity(
  'photos',
  {},
  {
    idAttribute: 'id'
  }
)
export const photoArray = [
  photoSchema
]
